export default (eventValue) => {
  const { on, id, key, value, params, data, schema, index } = eventValue;
  
  const isDev = process.env.NODE_ENV === 'development';

  if (isDev) {
    console.group(`🚀 Evento: '${on}' desde '${key}@${id}'`);
    console.log('Valor:', value);
    console.log('Modelo (Data):', data);
    console.log('Esquema:', schema);
    if (params) console.log('Params:', params);
    if (index !== undefined) console.log('Índice:', index);
    console.groupEnd();
  } 

  return eventValue;
};